import {
	ajax
} from 'application/src/js/functions.js';
import {
	materialUiColors
} from 'application/src/js/globals.js';

export default class StatisticList {
	constructor(args) {
		this.rawmaterialid = args.rawmaterialid;
		this.selectedLanguage = args.selectedLanguage;
		this.requestUrl = '/app/ajax/ajaxLoadRelatedTradeStatistics';
		this.debugMode = true;
		this.hideClass = 'hide';
		this.colors = [
			materialUiColors.amber,
			materialUiColors.lightGreen,
			materialUiColors.lime,
			materialUiColors.blueGrey,
		];
		this.container = document.querySelector('.statistics');
		this.importOuterContainer = document.querySelector('.import-statistics');
		this.importChartCanvas = this.importOuterContainer.querySelector('canvas');
		this.exportOuterContainer = document.querySelector('.export-statistics');
		this.exportChartCanvas = this.exportOuterContainer.querySelector('canvas');
		this.importChartData = {};
		this.exportChartData = {};


		this.load()
			.then(response => {
				this.importChartData = response.data.importChartData;
				this.exportChartData = response.data.exportChartData;

				if (response.data.importChartData.import_countries.length || response.data.exportChartData.export_countries.length) {
					this.container.classList.remove(this.hideClass);
					this.initGraph();
					this.updateGraph();
				}
			})
			.catch(e => {
				if (this.debugMode && e) console.log(e);
			});
	}

	initGraph() {
		var lng = this.selectedLanguage.replace('_' , '-');

		let importChartSettings = {
			type: 'pie',
			data: {
				datasets: [{
					data: [],
					backgroundColor: []
				}],
				labels: []
			},
			options: {
				plugins: {
					tooltip: {
						callbacks: {
							label: context => new Intl.NumberFormat(lng).format(context.raw)
						}
					},
					legend: {
						display: true,
						position: 'top',
						labels: {
							boxWidth: 15,
							padding: 10,
							fontSize: 12
						}
					}
				},
				bezierCurve: false,
				maintainAspectRatio: false,
				responsive: true
			}
		};

		this.importChart = new Chart(this.importChartCanvas, importChartSettings);

		let exportChartSettings = {
			type: 'pie',
			data: {
				datasets: [{
					data: [],
					backgroundColor: []
				}],
				labels: []
			},
			options: {
				plugins: {
					tooltip: {
						callbacks: {
							label: context => {
								return new Intl.NumberFormat(lng).format(context.raw);
							}
						}
					}
				},
				bezierCurve: false,
				maintainAspectRatio: false,
				responsive: true,
				legend: {
					display: true,
					position: 'top',
					labels: {
						boxWidth: 15,
						padding: 10,
						fontSize: 12
					}
				}
			}
		};

		this.exportChart = new Chart(this.exportChartCanvas, exportChartSettings);
	}

	load() {
		return ajax(this.requestUrl, {
			rawmaterialid: this.rawmaterialid,
			topCountries: 3
		});
	}

	updateGraph() {
		// import chart
		this.importChart.data.datasets = [{
			data: this.importChartData.import_amounts,
			backgroundColor: this.colors
		}];
		this.importChart.data.labels = this.importChartData.import_countries;
		this.importChart.update();

		// export chart
		this.exportChart.data.datasets = [{
			data: this.exportChartData.export_amounts,
			backgroundColor: this.colors
		}];
		this.exportChart.data.labels = this.exportChartData.export_countries;
		this.exportChart.update();
	}
}